import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";

import npiUpdatedDateApi from "apis/npiUpdatedDate";
import { Button, SubHeader, Typography } from "clearsense-ui/components";
import { Input, Select, Checkbox } from "clearsense-ui/components/formik";

import {
  ADDRESS_TYPE,
  INITIAL_NPI_REGISTRY_FORM_VALUES,
  NPI_REGISTRY_FORM_VALIDATIONS,
  NPI_TYPE,
  STATE_CODES,
  COUNTRY_CODES,
} from "../constants";

const Search = ({ handleSubmit }) => {
  const [updatedDate, setUpdatedDate] = useState();

  const fetchDate = async () => {
    const response = await npiUpdatedDateApi.fetchDate();
    setUpdatedDate(response.data.date ?? "Unknown");
  };

  useEffect(() => fetchDate(), []);

  return (
    <div className="cs-ui-container">
      <div className="mx-8">
        <SubHeader
          className="mt-8"
          breadcrumbs={[
            { label: "Reference Data", link: "#" },
            { label: "NPI", link: "#" },
          ]}
        />
        <Typography style="h3" className="m-4" type="semibold">
          Search NPI Records
        </Typography>
        <Formik
          initialValues={INITIAL_NPI_REGISTRY_FORM_VALUES}
          validationSchema={NPI_REGISTRY_FORM_VALIDATIONS}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, resetForm }) => (
            <Form className="flex-col px-5 pt-2 space-y-6">
              <div className="flex-col space-y-4">
                <Typography style="large" type="semibold">
                  Search By NPI Details
                </Typography>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="NPI Number"
                    name="npi"
                    className="col-span-1"
                    placeholder="Enter 10-digit number"
                  />
                  <Select
                    label="NPI Type"
                    defaultValue={NPI_TYPE[0]}
                    options={NPI_TYPE}
                    size="small"
                    placeholder="Select NPI Type"
                    className="col-span-1"
                    name="entityTypeCode"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    className="col-span-1"
                    label="Taxonomy Description"
                    name="taxonomyDescription"
                  />
                </div>
              </div>
              <div className="flex-col space-y-4">
                <Typography style="large" type="semibold">
                  Search By Name
                </Typography>
                <div className="flex-col space-y-2">
                  <Typography style="large" className="text-gray-500">
                    For individuals
                  </Typography>
                  <div className="flex flex-wrap gap-4">
                    <Input
                      label="First Name"
                      name="firstName"
                      placeholder="Enter First Name"
                      data-cy="npi-first-name-input"
                    />
                    <Input
                      label="Last Name"
                      name="lastName"
                      placeholder="Enter Last Name"
                      data-cy="npi-last-name-input"
                    />
                  </div>
                </div>
                <div className="flex-col space-y-2">
                  <Typography style="large" className="text-gray-500">
                    For organizations
                  </Typography>
                  <div className="grid grid-cols-2 gap-4">
                    <Input
                      label="Organization Name"
                      name="organizationName"
                      placeholder="Enter Name"
                      data-cy="npi-organization-name-input"
                      className="col-span-1"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-col space-y-4">
                <Typography style="large" type="semibold">
                  Search By Address
                </Typography>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="City"
                    name="city"
                    data-cy="npi-city-input"
                    className="col-span-1"
                  />
                  <Select
                    label="State"
                    className="col-span-1"
                    defaultValue={STATE_CODES[0]}
                    options={STATE_CODES}
                    size="small"
                    name="state"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <Select
                    label="Country"
                    className="col-span-1"
                    defaultValue={COUNTRY_CODES[0]}
                    options={COUNTRY_CODES}
                    size="small"
                    name="countryCode"
                  />
                  <Input
                    label="Postal Code"
                    name="postalCode"
                    className="col-span-1"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <Select
                    className="col-span-1"
                    label="Address Type"
                    defaultValue={ADDRESS_TYPE[0]}
                    options={ADDRESS_TYPE}
                    size="small"
                    name="addressType"
                  />
                </div>
              </div>
              <div className="flex-col space-y-6">
                <Checkbox
                  label={
                    <Typography style="large">
                      Search for <strong>Exact Matches</strong> only
                    </Typography>
                  }
                  name="exactMatch"
                  data-cy="npi-exact-match-checkbox"
                  className="pt-2"
                />
                <Typography style="medium">
                  {`* The NPI Search also returns results for partial search
                  terms. The information in this database was last updated on:
                  ${updatedDate}.`}
                </Typography>
                <div className="flex gap-4">
                  <Button
                    label="Clear"
                    style="secondary"
                    onClick={resetForm}
                    data-cy="npi-clear-button"
                  />
                  <Button
                    label="Search"
                    style="primary"
                    type="submit"
                    loading={isSubmitting}
                    data-cy="npi-search-button"
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Search;
